module.exports = __webpack_public_path__ + "media/2.6de779e7.mp3";